import { get } from "react-hook-form";
import { useAssetDetailsContext } from "../../../../context/assetDetailsContext";
import { getAssetLOTO } from "../../../../repositories/AssetDetailsRepositorie";

type Props = {
	setIsLoading: (isLoading: boolean) => void;
	setError: (err: string) => void;
};

export const useSearchAssetLOTO = ({ setIsLoading, setError }: Props) => {
	const {
		state: { assetSearchId },
		actions: { setListAssetLOTO },
	} = useAssetDetailsContext();

	return async (includeDescendants = false) => {
		setIsLoading(true);
		setListAssetLOTO([]);
		const res = await getAssetLOTO(assetSearchId, includeDescendants);
		if (res.ok) {
			const rowsSource = get(res, "data.tables[0].rows", []);
			setListAssetLOTO(rowsSource);
			setIsLoading(false);
		} else {
			setError(res.message);
			setIsLoading(false);
		}
	};
};
